import { IsBoolean } from 'class-validator';

export class PosValidateManagerPinResponseDto {
  @IsBoolean()
  public isManagementAccess: boolean;
  
  public managerEmployeeId: number;

  public managerEmployeeName: string;

  constructor(
    isManagementAccess: boolean,
    managerEmployeeId?: number,
    managerEmployeeName?: string
  ) {
      this.isManagementAccess = isManagementAccess;
      this.managerEmployeeId = managerEmployeeId;
      this.managerEmployeeName = managerEmployeeName;
    }
}
